

document.addEventListener("DOMContentLoaded", async function () {
    updateFSProgress()
  
});

async function getCartTotal() {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  return cart.total_price / 100; // total_price w centach
}

document.addEventListener('click', function (e) {
  const path = e.composedPath ? e.composedPath() : [];
  
  const button = path.find(el => {
    return el instanceof Element &&
      (el.matches?.('[data-essential-upsell-element="add-to-cart-button"]') || el.matches?.('input[type="checkbox"][aria-labelledby^="product-title-"]'));
  });

  if (!button) return;

  //console.log('klik upsell działa', button);
  handleUpsellClick(button);
}, true);

function handleUpsellClick(button) {
  //console.log('obsłużono klik', button);
  updateFSProgress();
}

async function updateFSProgress(){
  await new Promise(r => setTimeout(r, 1000));
  
    const progressFill = document.getElementById("progress-fill");
    const pAddon = document.getElementById("product-addon");
    const el = document.querySelector('.free-shipping');
    el.style.display = 'none';
    if (!progressFill) {
        console.error("Element #progress-fill nie został znaleziony.");
        return;
    }
    
    const freeShippingThreshold = 110.00;
    const cartTotal = await getCartTotal();
    const remainingAmount = Math.max(0, freeShippingThreshold - cartTotal);
    const progressPercentage = Math.floor(Math.min(100, (cartTotal / freeShippingThreshold) * 100));
    
    

    if(progressPercentage>=100){
      progressFill.style.setProperty("background", "#11A176", "important");
      progressFill.style.setProperty("width", progressPercentage + "%", "important");
      progressFill.style.setProperty("border", "1px solid #11A176", "important");
      document.getElementById('free-shipping-text').innerHTML = 'Brawo! Otrzymujesz <strong>darmową dostawę</strong>!';
      //document.getElementById('suggest').innerHTML ="";
      document.getElementById('delivery-price').innerHTML ="<strong>GRATIS</strong>";
      el.style.display = 'none';
      pAddon.style.display = 'block';
    }else{
      progressFill.style.setProperty("background", "#FFA500", "important");
    progressFill.style.setProperty("width", progressPercentage + "%", "important");
      progressFill.style.setProperty("border", "1px solid #FFA500", "important");
      document.getElementById('free-shipping-text').innerHTML = 'Do <strong>darmowej dostawy</strong> brakuje Ci: <strong id="remaining-amount">'+remainingAmount.toFixed(2)+'</strong> zł';
      //document.getElementById('suggest').innerHTML ="Dobierz przysmak i nie marnuj pieniędzy na dostawę! 😉";
      document.getElementById('delivery-price').innerHTML ="od 9.99 zł";
      document.querySelectorAll('.free-shipping').forEach(el => {
        el.style.display = 'block';
        pAddon.style.display = 'none';
      });

    }

}